export const BOOKING_STATUS = {
  PENDING: 0,
  PAID: 1,
  FAILED: 2,
  COMPLETED: 3,
  INCOMPLETE: 4,
};
